import React from 'react'

interface ProductCategorySelectorProps {
  mainCategories: string[]
  subCategories: Record<string, string[]>
  thirdLevelCategories: Record<string, Record<string, string[]>>
  selectedMainCategory: string
  selectedSubCategory: string
  selectedThirdCategory: string
  onMainCategoryChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  onSubCategoryChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  onThirdCategoryChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
}

const ProductCategorySelector: React.FC<ProductCategorySelectorProps> = ({
  mainCategories,
  subCategories,
  thirdLevelCategories,
  selectedMainCategory,
  selectedSubCategory,
  selectedThirdCategory,
  onMainCategoryChange,
  onSubCategoryChange,
  onThirdCategoryChange
}) => {
  return (
    <div className='category-selector'>
      <div className='form-group mb-3'>
        <label htmlFor='mainCategory'>Główna kategoria*</label>
        <select
          className='form-control'
          id='mainCategory'
          value={selectedMainCategory}
          onChange={onMainCategoryChange}
          required
        >
          <option value=''>Wybierz kategorię główną</option>
          {mainCategories.map(category => (
            <option key={category} value={category}>
              {category}
            </option>
          ))}
        </select>
      </div>

      {selectedMainCategory && (
        <div className='form-group mb-3'>
          <label htmlFor='subCategory'>Podkategoria</label>
          <select
            className='form-control'
            id='subCategory'
            value={selectedSubCategory}
            onChange={onSubCategoryChange}
          >
            <option value=''>Wybierz podkategorię</option>
            {subCategories[selectedMainCategory]?.map(category => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>
      )}

      {selectedMainCategory && selectedSubCategory && thirdLevelCategories[selectedMainCategory]?.[selectedSubCategory] && (
        <div className='form-group mb-3'>
          <label htmlFor='thirdCategory'>Trzeci poziom</label>
          <select
            className='form-control'
            id='thirdCategory'
            value={selectedThirdCategory}
            onChange={onThirdCategoryChange}
          >
            <option value=''>Wybierz kategorię</option>
            {thirdLevelCategories[selectedMainCategory][selectedSubCategory]?.map(category => (
              <option key={category} value={category}>
                {category}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  )
}

export default ProductCategorySelector
